export function setCookie(c_name, c_pwd, exdays) {
  let exdate = new Date(); //获取时间
  exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
  //字符串拼接cookie
  window.document.cookie =
    "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
  window.document.cookie =
    "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
}

//读取cookie
export function getCookie() {
  if (document.cookie.length > 0) {
    let arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
    return arr
  }
  return []
}
//清除cookie
export function clearCookie() {
  setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
}

export function isToday(dateTime) {
  let today = new Date()
  let todayY = today.getFullYear()
  let todayM = today.getMonth() + 1
  let todayD = today.getDate()
  //
  let date = new Date(dateTime)
  let dateY = date.getFullYear()
  let dateM = date.getMonth() + 1
  let dateD = date.getDate()

  if (todayY === dateY && todayM === dateM && todayD === dateD) {
    return true
  }
  return false
}

/** 当前分辨率--> 栅格 */
export function getScreenColValue() {
  let width = window.screen.width
  let col = ''
  if (width < 768) {
    col = 'xs'
  }
  if (width >= 768) {
    col = 'sm'
  }
  if (width >= 992) {
    col = 'md'
  }
  if (width >= 1200) {
    col = 'lg'
  }
  if (width >= 1920) {
    col = 'xl'
  }
  return col
}



// WEBPACK FOOTER //
// ./src/util/index.js